// components/PrivacyPolicy.tsx
import React from 'react';
import { privacyPolicy } from '../../constants/privacyPolicy';
import { Container } from 'reactstrap';
import SEO from '../../components/SEO';
import InnerBanner from '../../components/InnerBanner';
import BannerMask from '../../components/BannerMask';
import { parseContent } from '../../utils/parseContent';

interface PrivacyPolicyItem {
  section: string;
  content: (string | { items: string[] })[];
}

interface Props {
  privacyPolicy: PrivacyPolicyItem[];
}
const boldKeywords = ['privacy', 'data', 'personal information'];

const PrivacyPolicy = () => {
  return (
    <>
      <SEO title="Privacy Policy" />
      <div className="resource">
        <div className="banner section-with-border">
          <BannerMask />
          <div className="section-gap-lg">
            <Container>
              <InnerBanner
                title="Privacy Policy"
                description="Legalligence respects your privacy — see how we protect your data."
              />
            </Container>
          </div>
        </div>
        <section className="section-gap-lg">
          <Container>
            <div className="banner-short-content">
              <h2>Privacy Policy for Legalligence</h2>
              <p>Effective Date: 12-07-2025</p>
              <p>
                At Legalligence, we understand the sensitive nature of legal matters and are
                committed to protecting the privacy and security of your personal information. This
                Privacy Policy outlines how we collect, use, disclose, and safeguard your
                information when you use our AI-based legal website and services.
              </p>
              <p>
                By accessing or using Legalligence, you agree to the terms of this Privacy Policy.
                Please read it carefully.
              </p>
            </div>
            {privacyPolicy.map((section, idx) => (
              <div key={idx} className="policy-content">
                <h3>{section.section}</h3>

                {section.content.map((item, i) => {
                  if (typeof item === 'string') {
                    return <p key={i}>{parseContent(item)}</p>;
                  }

                  if (item.type === 'list') {
                    return (
                      <ul key={i}>
                        {item.items.map((li, j) => (
                          <li key={j}>{parseContent(li)}</li>
                        ))}
                      </ul>
                    );
                  }

                  return null;
                })}
              </div>
            ))}
          </Container>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
